import { H8BoldStyle, H10BoldStyle } from '../typos.mjs';

var buttonWidthMap = new Map([["l", 96], ["m", 80], ["s", 64]]);
var buttonHeightMap = new Map([["l", 48], ["m", 38], ["s", 32]]);
var buttonFontStyleMap = new Map([["l", H8BoldStyle], ["m", H10BoldStyle], ["s", H10BoldStyle]]);
var buttonPaddingMap = new Map([["l", 24], ["m", 16], ["s", 12]]);

export { buttonFontStyleMap, buttonHeightMap, buttonPaddingMap, buttonWidthMap };
